const generateString = (length) => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

export const inputElement = {
  id: 'input',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Input',
    fieldName: 'Input',
    name: 'input',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const inputSearchElement = {
  id: 'inputSearch',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Input Search',
    fieldName: 'Input Search',
    name: 'inputSearch',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    searchInputType: 'text',
    isSearchText: true,
    isSearchNumber: false,
    optionType: '',
    internal: {
      options: [],
      optionLabel: 'label',
      optionValue: 'value',
      dataKey: 'data',
      page: 1,
      perPage: 100,
    },
    external: {
      options: [],
      optionLabel: 'label',
      optionValue: 'value',
      dataKey: 'data',
      queryParams: [],
    },
  },
}

export const numberElement = {
  id: 'number',
  schema: {
    type: 'number',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Number',
    fieldName: 'Number',
    name: 'number',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const inputMaskElement = {
  id: 'inputMask',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Input Mask',
    fieldName: 'Input Mask',
    name: 'inputMask',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const textareaElement = {
  id: 'textarea',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Textarea',
    fieldName: 'Textarea',
    name: 'textarea',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const richtextElement = {
  id: 'richtext',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Rich Text',
    fieldName: 'Rich Text',
    name: 'richtext',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    datasource: [],
  },
}

export const dateElement = {
  id: 'date',
  schema: {
    type: 'string',
    format: 'date',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Date',
    fieldName: 'Date',
    name: 'date',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const timeElement = {
  id: 'time',
  schema: {
    type: 'string',
    format: 'time',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Time',
    fieldName: 'Time',
    name: 'time',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const dateTimeElement = {
  id: 'dateTime',
  schema: {
    type: 'string',
    format: 'date-time',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Date Time',
    fieldName: 'Date Time',
    name: 'dateTime',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    timestamp: false,
  },
}

export const selectElement = {
  id: 'select',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Select',
    fieldName: 'Select',
    name: 'select',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    optionType: 'custom',
    custom: {
      options: [],
      optionLabel: 'label',
      optionValue: 'value',
    },
  },
}

export const autocompleteElement = {
  id: 'autocomplete',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Autocomplete',
    fieldName: 'Autocomplete',
    name: 'autocomplete',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    optionType: 'custom',
    custom: {
      options: [],
      optionLabel: 'label',
      optionValue: 'value',
    },
  },
}

export const radioElement = {
  id: 'radio',
  schema: {
    type: 'boolean',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Radio',
    fieldName: 'Radio',
    name: 'radio',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    options: [{ name: 'radio1', label: 'radio 1' }],
  },
}

export const checkboxElement = {
  id: 'checkbox',
  schema: {
    type: 'boolean',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: 'default',
    type: 'Control',
    label: '',
    checkboxText: 'Checkbox',
    fieldName: 'Checkbox',
    name: 'checkbox',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const checkboxInputElement = {
  id: 'checkboxInput',
  schema: {
    type: 'boolean',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: 'default',
    type: 'Control',
    label: '',
    checkboxText: 'Checkbox',
    fieldName: 'Checkbox Input',
    name: 'checkboxInput',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const checkboxGroupElement = {
  id: 'checkboxGroup',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Checkbox Group',
    fieldName: 'Checkbox Group',
    name: 'checkboxGroup',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    options: [],
  },
}

export const labelElement = {
  id: 'label',
  schema: {
    type: 'string',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Control',
    label: 'Label',
    fieldName: 'Label',
    name: 'label',
    uiType: 'element',
    labelColor: 'black',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    formData: true,
    useLabelValue: true,
  },
}

export const basicElement = [
  labelElement,
  inputElement,
  inputSearchElement,
  numberElement,
  inputMaskElement,
  textareaElement,
  richtextElement,
  dateElement,
  timeElement,
  dateTimeElement,
  selectElement,
  autocompleteElement,
  radioElement,
  checkboxElement,
  checkboxInputElement,
  checkboxGroupElement,
]

export const buttonElement = {
  id: 'button',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Button',
    name: 'button',
    uiType: 'element',
    buttonText: 'Button',
    buttonColor: '#4099ff',
    buttonType: 'outline',
    buttonWidth: 'auto',
    buttonPosition: 'right',
    buttonIcon: '',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: 'onClick', name: '' },
    formData: false,
  },
}

export const buttonDropdownElement = {
  id: 'buttonDropdown',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Button Dropdown',
    name: 'buttonDropdown',
    uiType: 'element',
    buttonText: 'Button Dropdown',
    buttonColor: '#4099ff',
    buttonType: 'outline',
    buttonWidth: 'auto',
    buttonPosition: 'right',
    buttonIcon: '',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: 'onClick', name: '' },
    formData: false,
  },
}

export const favoriteButton = {
  id: 'favoriteButton',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Favorite Button',
    name: 'favoriteButton',
    uiType: 'element',
    buttonText: 'Favorite',
    buttonColor: '#4099ff',
    buttonType: 'outline',
    buttonWidth: 'auto',
    buttonPosition: 'right',
    buttonIcon: '',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    favorite: {
      isButton: true,
      enabled: true,
    },
    formData: false,
  },
}

export const tableElement = {
  id: 'table',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: 'Table',
    fieldName: 'Table',
    name: 'table',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    tableColumn: [],
    tableAction: {},
    loadData: {
      method: 'SEARCH',
      search: {},
    },
  },
}

export const customTableElement = {
  id: 'customTable',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: 'Custom Table',
    fieldName: 'Custom Table',
    name: 'customTable',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    tableColumn: [],
    tableAction: {},
    loadData: {
      method: 'SEARCH',
      search: {},
    },
  },
}

export const dividerElement = {
  id: 'divider',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: 'Divider',
    fieldName: 'Divider',
    name: 'divider',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: false,
  },
}

export const imageElement = {
  id: 'image',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Image',
    name: 'image',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    width: '100%',
    height: '480px',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const fileUploadElement = {
  id: 'fileUpload',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: '12',
    elementWidth: '12',
    type: 'Group',
    label: 'File Upload',
    fieldName: 'File Upload',
    name: 'fileUpload',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
    button: {
      upload: {
        layoutWidth: '12',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'uploadButton',
        uiType: 'element',
        buttonText: 'อัพโหลด',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'upload-cloud',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'uploadFile' },
        formData: false,
      },
    },
  },
}

export const imageCropperElement = {
  id: 'imageCropper',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: 'Image Cropper',
    fieldName: 'Image Cropper',
    name: 'imageCropper',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    width: '100%',
    height: '480px',
    action: { event: '', name: '' },
    formData: true,
    button: {
      crop: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'crop',
        uiType: 'element',
        buttonText: 'Crop รูป',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'crop',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'crop' },
        formData: false,
      },
      reset: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'reset',
        uiType: 'element',
        buttonText: 'Reset Crop',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'refresh-ccw',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'reset' },
        formData: false,
      },
      use: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'use',
        uiType: 'element',
        buttonText: 'ใช้รูปนี้',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'check',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'use' },
        formData: false,
      },
    },
  },
}

export const imageWebcamElement = {
  id: 'imageWebcam',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Image Webcam',
    name: 'imageWebcam',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    width: '100%',
    height: '480px',
    action: { event: '', name: '' },
    formData: true,
    button: {
      capture: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'capture',
        uiType: 'element',
        buttonText: 'Capture',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'camera',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'captureImage' },
        formData: false,
      },
      undo: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'reset',
        uiType: 'element',
        buttonText: 'Undo',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'corner-up-left',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'undoCapture' },
        formData: false,
      },
    },
  },
}

export const videoElement = {
  id: 'video',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Video',
    name: 'video',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    width: '100%',
    height: '480px',
    action: { event: '', name: '' },
    formData: true,
    button: {
      start: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'start',
        uiType: 'element',
        buttonText: 'Start',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'play',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'start' },
        formData: false,
      },
      pause: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'reset',
        uiType: 'element',
        buttonText: 'Pause',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'pause',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'pause' },
        formData: false,
      },
    },
  },
}

export const videoWebcamElement = {
  id: 'videoWebcam',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Video Webcam',
    name: 'videoWebcam',
    uiType: 'element',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    width: '100%',
    height: '480px',
    action: { event: '', name: '' },
    formData: true,
    button: {
      capture: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'capture',
        uiType: 'element',
        buttonText: 'Capture',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'camera',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'captureImage' },
        formData: false,
      },
      start: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'start',
        uiType: 'element',
        buttonText: 'Start Record',
        buttonColor: '#6f42c1',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'play',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'startRecord' },
        formData: false,
      },
      end: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'end',
        uiType: 'element',
        buttonText: 'End Record',
        buttonColor: '#ff5370',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'pause',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'endRecord' },
        formData: false,
      },
      undo: {
        layoutWidth: 'auto',
        labelWidth: 'auto',
        elementWidth: '',
        type: 'Group',
        label: '',
        name: 'reset',
        uiType: 'element',
        buttonText: 'Undo',
        buttonColor: '#4099ff',
        buttonType: 'outline',
        buttonWidth: 'auto',
        buttonPosition: 'center',
        buttonIcon: 'corner-up-left',
        isShowUi: true,
        isCanEdit: true,
        isCanDelete: true,
        title: '',
        action: { event: 'onClick', name: 'undoCapture' },
        formData: false,
      },
    },
  },
}

export const badgeElement = {
  id: 'badge',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Badge',
    name: 'badge',
    uiType: 'element',
    badgePrepend: '',
    badgeAppend: '',
    badgeColor: '#4099ff',
    textColor: '#fff',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const colorPickerElement = {
  id: 'colorPicker',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Color Picker',
    name: 'colorPicker',
    uiType: 'element',
    badgePrepend: '',
    badgeAppend: '',
    badgeColor: '#4099ff',
    textColor: '#fff',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const listElement = {
  id: 'list',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'List',
    name: 'list',
    uiType: 'element',
    listPrepend: '',
    listAppend: '',
    listColor: '#4099ff',
    textColor: '#fff',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const scoreChartElement = {
  id: 'scoreChart',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: 'Score Chart',
    fieldName: 'Score Chart',
    name: 'scoreChart',
    uiType: 'element',
    badgePrepend: '',
    badgeAppend: '',
    badgeColor: '#4099ff',
    textColor: '#fff',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    scoreSetting: {
      addScorePosition: 'left',
      addScoreNextInputKey: 'Enter',
      addScorePreviousRowKey: 'ArrowUp',
      addScoreNextRowKey: 'ArrowDown',
      addScoreLeftKey: 'ArrowLeft',
      addScoreRightKey: 'ArrowRight',
    },
    scoreConfig: [
      {
        group: false,
        label: 'Date',
        name: 'date',
        enabled: true,
        deletable: false,
        isDate: true,
        isDisableGroup: true,
        key: generateString(10),
      },
      {
        group: false,
        label: 'Time',
        name: 'time',
        readOnly: true,
        enabled: true,
        deletable: false,
        isTime: true,
        isDisableGroup: true,
        key: generateString(10),
      },
    ],
    formData: true,
  },
}

export const galleryElement = {
  id: 'gallery',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    elementWidth: '',
    type: 'Group',
    label: '',
    fieldName: 'Gallery',
    name: 'gallery',
    uiType: 'element',
    badgePrepend: '',
    badgeAppend: '',
    badgeColor: '#4099ff',
    textColor: '#fff',
    isCanEdit: true,
    isCanDelete: true,
    title: '',
    action: { event: '', name: '' },
    formData: true,
  },
}

export const systemElement = [
  buttonElement,
  buttonDropdownElement,
  favoriteButton,
  badgeElement,
  listElement,
  tableElement,
  customTableElement,
  dividerElement,
  galleryElement,
  imageElement,
  fileUploadElement,
  imageCropperElement,
  imageWebcamElement,
  videoElement,
  videoWebcamElement,
  scoreChartElement,
  colorPickerElement,
]

export const isFormData = {
  input: inputElement.uischema.formData,
  inputSearch: inputSearchElement.uischema.formData,
  number: numberElement.uischema.formData,
  checkbox: checkboxElement.uischema.formData,
  select: selectElement.uischema.formData,
  date: dateElement.uischema.formData,
  time: timeElement.uischema.formData,
  dateTime: dateTimeElement.uischema.formData,
  table: tableElement.uischema.formData,
  customTable: customTableElement.uischema.formData,
  autocomplete: autocompleteElement.uischema.formData,
  fileUpload: fileUploadElement.uischema.formData,
}

export const convertElementSchema = {
  string: 'input',
  email: 'input',
  uri: 'input',
  number: 'number',
  boolean: 'checkbox',
  enum: 'select',
  date: 'date',
  tile: 'time',
  date_time: 'dateTime',
  datetime: 'dateTime',
  'date-time': 'dateTime',
  'data-url': 'fileUpload',
  array: 'table',
  oneOf: 'select',
}

export const convertElement = [
  { title: inputElement.uischema.fieldName, value: inputElement.id },
  {
    title: inputSearchElement.uischema.fieldName,
    value: inputSearchElement.id,
  },
  {
    title: numberElement.uischema.fieldName,
    value: numberElement.id,
  },
  { title: textareaElement.uischema.fieldName, value: textareaElement.id },
  { title: inputMaskElement.uischema.fieldName, value: inputMaskElement.id },
  { title: checkboxElement.uischema.fieldName, value: checkboxElement.id },
  { title: selectElement.uischema.fieldName, value: selectElement.id },
  { title: dateElement.uischema.fieldName, value: dateElement.id },
  { title: timeElement.uischema.fieldName, value: timeElement.id },
  { title: dateTimeElement.uischema.fieldName, value: dateTimeElement.id },
  { title: tableElement.uischema.fieldName, value: tableElement.id },
  { title: customTableElement.uischema.fieldName, value: customTableElement.id },
  {
    title: autocompleteElement.uischema.fieldName,
    value: autocompleteElement.id,
  },
]
